// extracted by mini-css-extract-plugin
export default {"editIcon":"MedicationsTable_editIcon__mnFFM","tableHeader":"MedicationsTable_tableHeader__zFHOL"};